import mutations from './dailyPatient.mutations'
import actions from './dailyPatient.actions'
import getters from './dailyPatient.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
